import axios from "axios";
import config from "../config";
import type { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

export type RssFeedMode = "draft" | "auto";

export type RssFeed = {
  id: number;
  name: string;
  feed_url: string;
  mode: RssFeedMode;
  is_active: boolean;
  poll_interval_minutes?: number;
  last_polled_at?: string | null;
  last_error_at?: string | null;
  last_error_message?: string | null;
  created_at?: string | null;
};

export type RssFeedPayload = {
  name: string;
  feed_url: string;
  mode: RssFeedMode;
  is_active?: boolean;
};

export const getRssFeeds = (): Promise<ApiSuccess<RssFeed[]>> =>
  axios.get(apiBase + "/rss-feeds");

export const createRssFeed = (
  payload: RssFeedPayload
): Promise<ApiSuccess<RssFeed>> => axios.post(apiBase + "/rss-feeds", payload);

export const updateRssFeed = (
  id: number,
  payload: Partial<RssFeedPayload>
): Promise<ApiSuccess<RssFeed>> =>
  axios.patch(`${apiBase}/rss-feeds/${id}`, payload);

export const deleteRssFeed = (id: number): Promise<ApiSuccess<null>> =>
  axios.delete(`${apiBase}/rss-feeds/${id}`);

export const pollRssFeed = (id: number): Promise<ApiSuccess<RssFeed>> =>
  axios.post(`${apiBase}/rss-feeds/${id}/poll`);

export type RssFeedPreview = {
  title: string;
  subject: string;
  item_url?: string | null;
  html_body: string;
};

export const previewRssFeed = (id: number): Promise<
  ApiSuccess<RssFeedPreview | null>
> => axios.post(`${apiBase}/rss-feeds/${id}/preview`);
